import { Container } from '@pixi/react'
import { SpinePlayer } from '@slot-nx/core'
import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { winningService } from '../domain/winning/WinningService'
import { useGameStore } from '../domain/game/store/GameStore'

export const Winbar = () => {
  const winBarContainerRef = useRef<PixiContainer>(null)
  const totalMultiplierContainerRef = useRef<PixiContainer>(null)
  const multiplierContainerRef = useRef<PixiContainer>(null)
  const [isFreeGame] = useGameStore(state => [state.isFreeGame])
  useEffect(() => {
    if (winBarContainerRef.current) {
      winningService.setWinBarContainer(winBarContainerRef.current)
    }
    if (totalMultiplierContainerRef.current) {
      winningService.setTotalMultiplierContainer(totalMultiplierContainerRef.current)
    }
    if (multiplierContainerRef.current) {
      winningService.setMultiplierContainer(multiplierContainerRef.current)
    }
  }, [])

  return (
    <Container name="winBarRootContainer" position={[540, 1335]}>
      {/* <Image name="winBarBg Image" anchor={0.5} x={0} y={0} image="Image_tumbleWinBar" /> */}
      <Container name="tumbleWinBar" anchor={0.5} x={0} y={0}>
        <SpinePlayer
          name="tumbleWinBar"
          playOnLoad={true}
          data="tumbleBar.skel"
          atlas="tumbleBar.atlas"
          x={0}
          y={0}
          animationStr="loop"
          onCreatedSpine={spine => winningService.setTumbleWinBar(spine)}
          loop={true}
        />
      </Container>
      <Container name="winBarAmountContainer" ref={winBarContainerRef} x={0} y={-15} />
      <Container visible={isFreeGame} name="totalMultiplierContainer" ref={totalMultiplierContainerRef} x={-330} y={-10}>
        <SpinePlayer
          name="totalMultiplierFrame"
          playOnLoad={true}
          data="multiplyFrameB.skel"
          atlas="multiplyFrameB.atlas"
          x={-70}
          y={-5}
          animationStr="loop"
          onCreatedSpine={spine => winningService.setTotalMultiplierSpineBox(spine)}
          loop={true}
        />
      </Container>
      <Container name="multiplierContainer" ref={multiplierContainerRef} alpha={0} x={275} y={0}>
        <SpinePlayer
          name="multiplierFrame"
          playOnLoad={true}
          data="multiplyFrameA.skel"
          atlas="multiplyFrameA.atlas"
          x={0}
          y={0}
          animationStr="loop"
          onCreatedSpine={spine => winningService.setMultiplierSpineBox(spine)}
          loop={true}
        />
      </Container>
    </Container>
  )
}
